import type { JobPost } from "../types";

type PublishResult = {
  id: string;
  status: string;
  turnstileSkipped?: boolean;
};

export function cloudBoardEnabled(): boolean {
  return import.meta.env.VITE_PUBLIC_BOARD_ENABLED !== "false";
}

export async function publishJobToCloud(
  job: JobPost,
  turnstileToken?: string,
): Promise<PublishResult> {
  const response = await fetch("/api/jobs", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      turnstileToken,
      title: job.title,
      summary: job.summary,
      category: job.category,
      neighborhood: job.neighborhood,
      city: job.city,
      state: job.state,
      budgetMin: job.budgetMin,
      budgetMax: job.budgetMax,
      desiredWindow: job.desiredWindow,
      urgency: job.urgency,
      scopeItems: job.scopeItems,
      riskFlags: job.riskFlags,
      readiness: job.readiness,
      contact: job.contact,
      materialNotes: job.materialNotes,
    }),
  });

  const payload = (await response.json()) as PublishResult | { error?: string };
  if (!response.ok) {
    throw new Error("error" in payload && payload.error ? payload.error : "Cloud publish failed.");
  }
  return payload as PublishResult;
}
